(() => {
  function handleSaveButtons() {
    const saveButtons = [...document.querySelectorAll('status-save-button')]
    if (saveButtons.length) {
       // ------------TD CHANGE-----------
      const saveButtonStyling = `
        * {
          text-transform: uppercase;
        }
        .save-button {
          position: relative;
          z-index: 1;
          color: #1b1b1b !important;
        }        
      `
        // --------- END TD CHANGE--------
      const saveButtonStyle = new CSSStyleSheet
      saveButtonStyle.replaceSync(saveButtonStyling)
      saveButtons.forEach((button) => {
        if(button.shadowRoot) {
           button.shadowRoot.adoptedStyleSheets.push(saveButtonStyle)
        }
       
        document.addEventListener('status:item:save', ({detail}) => {
          if (detail.productId == button.productId && button.getAttribute('selected-label')) {
            button.innerText = button.getAttribute('selected-label')
          }
        })
        document.addEventListener('status:item:remove', ({detail}) => {
          if (detail.productId == button.productId && button.getAttribute('deselected-label')) {
            button.innerText = button.getAttribute('deselected-label')
          }
        })
      }) 
    }
  }
  // ------------TD CHANGE-----------
  function handleWishlistTriggers() {
    const wishlistTriggers = [...document.querySelectorAll('status-saved-link')]
    if (wishlistTriggers.length) {
      const wishlistTriggersStyling = `
        .indicator {
          font-size: .625rem;
          font-weight: 600;
          width: 17px;
          height: 17px;
          display: flex;
          justify-content: center;
          align-items: center;
          top: 0;
          right: -9px;
        }
      `
      const wishlistTriggersStyling2 = `
        .indicator {
          opacity:0;
        }
      `
      const wishlistTriggersStyle = new CSSStyleSheet
      const wishlistTriggersStyle2 = new CSSStyleSheet
      wishlistTriggersStyle.replaceSync(wishlistTriggersStyling)
      wishlistTriggersStyle2.replaceSync(wishlistTriggersStyling2)
      wishlistTriggers.forEach((trigger) => {
        const ind = trigger.shadowRoot.querySelector('.indicator') != null && trigger.shadowRoot.querySelector('.indicator').innerHTML 
        if(ind) {

          if(ind !== '0') {
            trigger.shadowRoot.adoptedStyleSheets.push(wishlistTriggersStyle)
          } else {
            trigger.shadowRoot.adoptedStyleSheets.push(wishlistTriggersStyle2)
          }
        }
        
        
      })
    }
  }
  // --------- END TD CHANGE--------
  document.addEventListener("status:loaded", () => {
    handleSaveButtons();
    handleWishlistTriggers();
  })
  document.addEventListener('quick-view:open', handleSaveButtons)
})()

// --------- Accordion --------

if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.options = null;
      this.items = [];
      this.itemsById = new Map();
      this.onlyOneActive = false;
      this._listenersInitialized = false;

      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      // Initialize instance variables here (Web Component best practice).
      this.options = this.dataset.options;
      this.refreshItems();
      this.setupEventListeners();

      // If an item is pre-opened, set its height without forcing this work into a user interaction.
      window.requestAnimationFrame(() => {
        this.items.forEach((item) => {
          if (!item.classList.contains("is-active")) return;
          const content = item.querySelector(".td-accordion__content");
          if (!content) return;
          content.style.maxHeight = content.scrollHeight + "px";
        });
      });
    }

    refreshItems() {
      this.items = Array.from(this.querySelectorAll(".td-accordion__item"));
      this.itemsById = new Map(this.items.map((item) => [String(item.dataset.item), item]));
    }

    toggle(currentItem) {
      const currentKey = String(currentItem);
      const item = this.itemsById.get(currentKey);
      if (!item) return;

      const content = item.querySelector(".td-accordion__content");
      if (!content) return;

      if (item.classList.contains("is-active")) {
        item.classList.remove("is-active");
        content.style.maxHeight = null;
      } else {
        item.classList.add("is-active");
        // Defer layout measurement so the click interaction remains responsive (INP).
        window.requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + "px";
        });
      }

      if (this.onlyOneActive) {
        this.items.forEach((other) => {
          if (other === item) return;
          other.classList.remove("is-active");
          const otherContent = other.querySelector(".td-accordion__content");
          if (otherContent) otherContent.style.maxHeight = null;
        });
      }
    }

    setupEventListeners() {
      if (this._listenersInitialized) return;
      this._listenersInitialized = true;

      // Event delegation keeps listeners minimal and resilient to inner markup changes.
      this.addEventListener("click", this.onClick);
    }

    onClick(event) {
      const toggle = event.target.closest(".td-accordion__toggle, .td-accordion__toggle-next");
      if (!toggle) return;

      // Prevent expensive document-level click handlers (often from apps) from running on this interaction.
      event.stopPropagation();
      event.preventDefault();

      const item = toggle.closest(".td-accordion__item");
      if (!item) return;

      // Keep the click interaction lightweight; schedule the work for the next frame.
      if (toggle.classList.contains("td-accordion__toggle-next")) {
        const nextItem = String(parseInt(item.dataset.item, 10) + 1);
        window.requestAnimationFrame(() => this.toggle(nextItem));
        return;
      }

      window.requestAnimationFrame(() => this.toggle(item.dataset.item));
    }
  }

  customElements.define("accordion-wrapper", Accordion);
}

document.addEventListener("DOMContentLoaded", function () {
  window.upcartOnCartLoaded = function (cart) {
    if (!cart || cart.item_count > 0) return;
    const cartFooter = document.querySelector(".upcart-footer");
    if(cartFooter) {
      const loopOnstore = document.createElement('loop-onstore');
      cartFooter.appendChild(loopOnstore);
    }
    const customEmptyCart = document.querySelector("[data-empty-cart]");
    const customEmptyCartWrapper = document.querySelector(
      '#upCart div[class^="styles_CartPreview__empty"]'
    );
    if (!customEmptyCart || !customEmptyCartWrapper) return;
    customEmptyCartWrapper.innerHTML = customEmptyCart.innerHTML;
  };
});

// Sauce basket upsell gallery
window.addEventListener('aftersell-upcart:public-events:cart-loaded', function () {
  const upsellContainer = document.querySelector('.sauce-basket-upsell-container');
  if (!upsellContainer) return;

  // Remove all existing children
  while (upsellContainer.firstChild) {
    upsellContainer.removeChild(upsellContainer.firstChild);
  }

  // Create and insert the widget script
  const script = document.createElement('script');
  script.src = 'https://app.addsauce.com/widgets/basket_upsell/38018b6d-265d-81a3-05b6-27ff27c56dce/_basket_upsell_gallery.js';
  script.className = 'snapppt-widget';
  upsellContainer.appendChild(script);
});
